// Persistent bar so the operator can never mistake local for production. Env is resolved by
// hostname (see lib/env.ts) — there is no API-surfaced mode field.
import { getEnvironment, type Environment } from '../lib/env';

const STYLES: Record<Environment, string> = {
  local: 'bg-green-600 text-white dark:bg-green-700',
  production: 'bg-orange-500 text-white dark:bg-orange-600',
};

const LABELS: Record<Environment, string> = {
  local: 'Local Environment',
  production: 'Production Environment',
};

export function EnvBanner() {
  const environment = getEnvironment();

  return (
    <div
      data-id="em-mgr--shell--env-banner"
      className={`w-full py-1 text-center text-xs font-semibold tracking-wide uppercase ${STYLES[environment]}`}
    >
      {LABELS[environment]}
    </div>
  );
}
